import { memo } from 'react'

import css from './PageNotFound.module.scss'

import Button from '@/components/Button'
import Heading from '@/components/Heading'

import HomeIcon from '@/assets/svgs/home-route.svg?react'

export interface ViewProps {
  onLanding: () => void
}

const View = memo(function PageNotFoundView({ onLanding }: ViewProps) {
  return (
    <section className={`PageNotFound ${css.root}`} aria-label="Page not found">
      <div className={css.content}>
        <p className={css.code}>404</p>
        <Heading as="h1" className={css.title}>
          Page not found
        </Heading>
        <p className={css.description}>This page may have moved, or the link may be incorrect. Let’s get you back.</p>
        <Button className={css.action} onClick={onLanding}>
          <HomeIcon aria-hidden="true" focusable="false" />
          Back to landing
        </Button>
      </div>
    </section>
  )
})

View.displayName = 'PageNotFound_View'
export default View
